import React from 'react';
import { FiBell } from 'react-icons/fi';

export default function Topbar({ user }) {
  return (
    <header className="flex items-center justify-between p-6 bg-white border-b">
      <div>
        <h1 className="text-3xl font-extrabold text-gray-800">Bom dia, {user?.name || 'Usuário'}. 👋</h1>
        <p className="text-sm text-gray-500 mt-1">Aqui está o resumo do que está acontecendo hoje.</p>
      </div>

      <div className="flex items-center gap-4">
        {/* Notifications are temporarily disabled — will be used in future */}
        { /*
        <div className="relative">
          <button className="relative p-2 rounded-lg hover:bg-gray-50">
            <FiBell className="w-5 h-5 text-gray-600" />
            <span className="absolute -top-1 -right-1 inline-flex items-center justify-center px-1.5 py-0.5 text-xs font-medium leading-none text-white bg-purple-600 rounded-full">3</span>
          </button>
        </div>
        */ }

        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-full bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center text-gray-600">MT</div>
          <div className="text-right">
            <div className="text-sm font-medium">{user?.name || 'Mateus Teixeira'}</div>
            <div className="text-xs text-gray-500">{user?.role || 'Administrador'}</div>
          </div>
        </div>
      </div>
    </header>
  );
}
